import { ApplicationController, useTransition, useClickOutside } from 'stimulus-use';

export default class extends ApplicationController {
  static targets = ['wrapper', 'backdrop', 'panel'];

  static values = { url: String };

  connect() {
    window.addEventListener('turbo:morph', () => {
      this.enable();
    });
    this.enable();
  }

  enable() {
    useTransition(this, { element: this.backdropTarget });
    useClickOutside(this, { element: this.panelTarget });
    this.wrapperTarget.classList.add('hidden');
  }

  open(event) {
    event.preventDefault();
    this.urlValue = event.currentTarget.href;
    this.wrapperTarget.classList.remove('hidden');
    this.enter();
  }

  close() {
    this.dismiss();
  }

  continue() {
    window.location = this.urlValue;
  }

  clickOutside() {
    this.dismiss();
  }

  dismiss() {
    Promise.all([
      this.leave(),
    ]).then(() => this.wrapperTarget.classList.add('hidden'));
  }
}
